<div *ngIf="!loading">
  <p-carousel 
  [value]="cursos" 
  styleClass="custom-carousel" 
  [numVisible]="itemsPerPage" 
  [numScroll]="1" 
  [circular]="circular" 
  [autoplayInterval]="autoplayInterval" 
  [responsiveOptions]="responsiveOptions"
  showIndicators="true"
  showNavigators="true"
>
  <ng-template let-curso pTemplate="item">
    <div class="p-mr-2 curso-item-content" style="height: 100%;">
      <div class="p-card-enabled" style="height: 100%;">
        <p-card (click)="goFormulario(curso.id, curso.version)" >
          <ng-template pTemplate="header">
            <div class="img" [style]="{backgroundImage: 'url(' + curso.imagen_base64 + ')', backgroundSize: 'cover'}">
              <div style="min-height: 220px;"></div>
            </div>
          </ng-template>
          <div class="p-d-flex p-p-2 p-flex-nowrap p-jc-between">
            <small class="p-text-left" style="max-width: 140px; font-size: .8rem;">{{ curso.categoria }}</small>
            <small class="curso-duracion p-as-center" style="font-size: .7rem; color: #000">{{ curso.duracion}} Horas</small>
          </div>
          <div class="p-text-left p-p-2">
            <h3 class="p-mb-0 p-mt-0 p-text-nowrap p-text-truncate" style="font-size: .93rem; max-width: 200px;">{{ curso.nombre }}</h3>
            <div class="p-mt-1 p-mb-2">
              <!-- Muestra el tipo de curso -->
              <small class="p-py-0 p-my-0" style="font-size: .7rem">{{curso.tipoCurso}}</small><br>
              <!-- Muestra valor dependiendo del tipo de curso -->              
              <p class="p-py-0 p-my-0" *ngIf="curso.tipoCurso !== 'GRATUITO' && curso.tipoCurso !== 'PRIVADO'"  style="font-size: .7rem">Valor M.: $ {{ curso.valorMatricula }}</p>
              <p class="p-py-0 p-my-0" *ngIf="curso.tipoCurso !== 'GRATUITO' && curso.tipoCurso !== 'PRIVADO'"  style="font-size: .7rem">Valor A.: $ {{ curso.valorArancel }}</p>
            </div>
            <div>
              <small *ngIf="curso.estado == 'INACTIVO'" class="p-text-uppercase p-card-nodisponible" style="font-size: .7rem"><i class="pi pi-times-circle p-mr-1" style="top: 2px; position:relative;"></i> No disponible</small>
              <small *ngIf="curso.estado !== 'INACTIVO'" class="p-text-uppercase p-card-disponible" style="font-size: .7rem"><i class="pi pi-info-circle p-mr-1" style="top: 2px; position:relative;"></i> Más info </small>
            </div>
            <div *ngIf="curso.requiereCodigo" class="p-mt-2">
              <small [ngClass]="curso.estado !== 'INACTIVO' ? 'p-text-uppercase p-card-exclusivo' : 'p-text-uppercase p-card-text-disabled p-card-nodisponible'" style="font-size: .7rem"><i class="pi pi-key p-mr-1" style="top: 2px; position:relative;"></i> Requiere código</small>
            </div>
          </div>
        </p-card>
      </div>

    </div>
  </ng-template>
</p-carousel>
</div>

<div *ngIf="loading">
  <p-carousel 
  [value]="[1, 2, 3, 4]" 
  styleClass="custom-carousel" 
  [numVisible]="itemsPerPage" 
  [numScroll]="1" 
  [circular]="circular" 
  [autoplayInterval]="autoplayInterval" 
  [responsiveOptions]="responsiveOptions"
  showIndicators="true"
  showNavigators="true"
>
  <ng-template let-curso pTemplate="item">
    <div class="p-mr-2 curso-item-content" style="height: 100%;">
      <div style="height: 100%;">
        <p-card>
          <ng-template pTemplate="header">
            <div style="width: 100%;">
              <p-skeleton width="100%" height="220px"></p-skeleton>
            </div>
          </ng-template>
          <div class="p-p-2 p-d-flex p-flex-nowrap p-jc-between">
            <small class="p-text-left" style="max-width: 120px; font-size: .8rem;" > Cargando las categorias... </small>
            <small class="curso-duracion p-as-center" style="font-size: .7rem"> N° Horas</small>
          </div>
          <div class="p-text-left p-p-2" style="opacity: .5; margin-top: 5px;">
            <h3 class="p-mb-0 p-mt-0" style="font-size: .93rem" >Cargando... </h3>
            <div class="p-mt-1 p-mb-2">
              <!-- Muestra el tipo de curso -->
              <div style="width: 90px; height: 5px;">
              </div>
            </div>
            <div>
              <small class="p-text-uppercase p-card-disponible" style="font-size: .7rem"><i class="pi pi-info-circle p-mr-1" style="top: 2px; position:relative;"></i> Más info </small>
            </div>
   
          </div>
        </p-card>
      </div>

    </div>
  </ng-template>
</p-carousel>
</div>
